import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { AlertModule } from '@epicuro-next/ataraxia/alert';
import { ConcatenatedFieldsPipe } from '@epicuro-next/ataraxia/concatenated-object-fields';
import { IconsModule } from '@epicuro-next/ataraxia/icons';
import { ImageModule } from '@epicuro-next/ataraxia/image';
import { InfiniteScrollModule } from '@epicuro-next/ataraxia/infinite-scroll';
import { InputModule } from '@epicuro-next/ataraxia/input';
import { InputWithIconModule } from '@epicuro-next/ataraxia/input-with-icon';
import { LoaderOverlayModule } from '@epicuro-next/ataraxia/loader-overlay';
import { ModalModule } from '@epicuro-next/ataraxia/modal';
import { TextFinderModule } from '@epicuro-next/ataraxia/text-finder';
import {
  ACCOUNTS_FEATURE_NAME,
  ConfigurationModule,
} from '@epicuro-next/platform/configuration';
import { PBasketStateModule } from '@epicuro-next/state/p-basket-state';
import { StateSitesStateModule } from '@epicuro-next/state/site-state';
import { LetDirective, PushPipe } from '@ngrx/component';
import { RxFor } from '@rx-angular/template/for';

import {
  AccountDetailsComponent,
  AccountInformationComponent,
  AccountsFormComponent,
  MenuActiveAccountsComponent,
  SelectedAccountsComponent,
} from './components';
import {
  AccountSelectorBaseComponent,
  AccountSelectorMenuComponent,
  AccountSelectorModalComponent,
  SearchAccountsInputComponent,
  SelectAccountsPageComponent,
} from './containers';
import { MerchandiseBackgroundComponent } from './containers/merchandise-background/merchandise-background.component';
import { ActiveAccountGuard } from './services/active-account.guard';

@NgModule({
  imports: [
    TextFinderModule,
    CommonModule,
    ConfigurationModule.forFeature(ACCOUNTS_FEATURE_NAME),
    InputWithIconModule,
    ReactiveFormsModule,
    IconsModule,
    InputModule,
    ModalModule,
    InfiniteScrollModule,
    StateSitesStateModule,
    PBasketStateModule,
    LetDirective,
    PushPipe,
    AlertModule,
    LoaderOverlayModule,
    ImageModule,
    ConcatenatedFieldsPipe,
    RxFor,
  ],
  declarations: [
    AccountsFormComponent,
    SelectAccountsPageComponent,
    AccountSelectorBaseComponent,
    AccountSelectorModalComponent,
    AccountSelectorMenuComponent,
    SearchAccountsInputComponent,
    MenuActiveAccountsComponent,
    AccountInformationComponent,
    SelectedAccountsComponent,
    AccountDetailsComponent,
    MerchandiseBackgroundComponent,
  ],
  exports: [
    AccountSelectorMenuComponent,
    MenuActiveAccountsComponent,
    AccountDetailsComponent,
  ],
  providers: [ActiveAccountGuard],
})
export class AccountsSelectorModule {}
